import { Stack } from '@chakra-ui/react';
import Hero from '@components/semLandingPages/movers/Hero';
import LandingBottomCTA from '@components/semLandingPages/movers/LandingBottomCTA';
import Reviews from '@components/semLandingPages/Reviews';
import BBB from 'landing/BBB';
import BlueBoxSlogan from 'landing/BlueBoxSlogan';
import Carriers from 'landing/Carriers';
import { contentAndImage } from 'landing/content/ContentAndImages';
import ContentWithImage from 'landing/ContentWithImage';
import Testimonials from 'landing/Testimonials';
import DefaultLayout from '../components/layout/layout/DefaultLayout';

function Home() {
  return (
    <DefaultLayout>
      <Hero />
      <Stack maxW="1200px" m="auto" p={[4, 6, 10]} spacing="120px" mt={20}>
        <Reviews />
        <BBB />
        <Carriers />
        <BlueBoxSlogan />
        {Object.keys(contentAndImage).map((obj, i) => (
          <ContentWithImage key={i} content={contentAndImage[obj]} />
        ))}
        <Testimonials />
        <LandingBottomCTA />
      </Stack>
    </DefaultLayout>
  );
}

export default Home;
